import Observer from '../classes/Observer';

class ScrollReveal extends Observer {
  public $targets: JQuery;

  constructor($targets = $(), rootMargin = '0px 0px -15% 0px') {
    super({
      isOnce: true,
      rootMargin: rootMargin,
    });
    this.$targets = $targets;
    this.observe(this.$targets);
  }

  revealTargets($elements: JQuery) {
    $elements.each((i, target) => {
      this.observer?.observe(target);
    });
  }

  animateIn(target?: Element) {
    super.animateIn();
    if (!target) return;
    // target.classList.add('is-visible');
    // add [data-is-visible] attribute to target
    target.setAttribute('data-is-visible', 'true');
  }
}

export default ScrollReveal;
